import React from 'react';
import {
  StyledAccordion,
  ToggleLabelText,
  ToggleLabelHeader,
  Graphic,
  WjaContainer,
  WjaToggleHeader,
  WjaToggleHeaderTitle,
  WjaToggleBody,
  WjaToggleBodyExtens,
  WjaToggleBodyExtensContainer,
  WjaToggleBodyExtensContainerDesc,
  WjaToggleBodyExtensContainerButton,
  WjaToggleBodyExtensContainerButtonText
} from '../styles/privacySettingsStyles';
import IconMegaphone from '@veneer/core/dist/scripts/icons/icon_megaphone';
import IconJobs from '@veneer/core/dist/scripts/icons/icon_jobs';
import IconShare from '@veneer/core/dist/scripts/icons/icon_share';
import Toggle from '@veneer/core/dist/scripts/toggle';
import svgAnalytics from '../assets/analytics.svg';
import svgPersonalized from '../assets/personalized.svg';

const PrivacyConsents = ({
  isPipl,
  isDesktop,
  appRequiredTitle,
  appAnalyticsContent,
  advertisingContent,
  analytics,
  advertising,
  personalizedSuggestions,
  dataTransfer,
  setAnalytics,
  setAdvertising,
  setPersonalizedSuggestions,
  setDataTransfer,
  personalizedSuggestionsContent = '',
  dataTransferContent = '',
  printerWelcome,
  defaultConsentContent,
  appAnalyticsTitle,
  advertisingTitle,
  personalizedTitle,
  appOptionalDataUseDesc,
  setRenderPageAnyToggleClick,
  appOptionalTitle,
  appDataTransferTitle,
  hasAppNameWJA
}) => {
  const userConsentsAccordionItems = [
    {
      content: <ToggleLabelHeader dangerouslySetInnerHTML={{ __html: appAnalyticsContent }} />,
      header: {
        startArea: <Graphic id="graphic-analytics" src={svgAnalytics} alt="analytics" />,
        centralArea: <ToggleLabelHeader>{appAnalyticsTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setAnalytics-btn"
            id="app-analytics-toggle"
            on={analytics}
            defaultOn={analytics}
            onChange={(e) => {
              setAnalytics(e);
            }}
          />
        )
      },
      id: 'app-analytics-accordion-item',
      expanded: true
    },
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: advertisingContent }} />,
      header: {
        startArea: <IconMegaphone id="graphic-advertising" alt="advertising" />,
        centralArea: <ToggleLabelHeader>{advertisingTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setAdvertising-btn"
            id="advertising-toggle"
            on={advertising}
            defaultOn={advertising}
            onChange={(e) => {
              setAdvertising(e);
            }}
          />
        )
      },
      id: 'advertising-accordion-item',
      expanded: isDesktop
    },
    {
      content: (
        <ToggleLabelText
          dangerouslySetInnerHTML={{
            __html: personalizedSuggestionsContent
          }}
        />
      ),
      header: {
        startArea: (
          <Graphic id="graphic-personalized-suggestions" src={svgPersonalized} alt="personalized" />
        ),
        centralArea: <ToggleLabelHeader>{personalizedTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setPersonalizedSuggestions-btn"
            id="personalized-suggestions-toggle"
            defaultOn={personalizedSuggestions}
            on={personalizedSuggestions}
            onChange={(e) => {
              setPersonalizedSuggestions(e);
            }}
          />
        )
      },
      id: 'personalized-suggestions-accordion-item',
      expanded: isDesktop
    }
  ];

  const printerConsentsAccordionItems = [
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: defaultConsentContent }} />,
      header: {
        startArea: <IconJobs id="graphic-required" alt="required" />,
        centralArea: <ToggleLabelHeader>{appRequiredTitle}</ToggleLabelHeader>
      },
      id: 'app-required-accordion-item',
      expanded: true
    },
    ...userConsentsAccordionItems
  ];

  const wjaConsentsAccordionItems = [
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: defaultConsentContent }} />,
      header: {
        centralArea: <ToggleLabelHeader>{appRequiredTitle}</ToggleLabelHeader>
      },
      id: 'app-required-accordion-item',
      expanded: isDesktop
    },
    {
      content: (
        <WjaContainer>
          <WjaToggleHeader>
            <Graphic id="graphic-analytics" src={svgAnalytics} alt="analytics" />
            <WjaToggleHeaderTitle>{appAnalyticsTitle}</WjaToggleHeaderTitle>
          </WjaToggleHeader>
          <WjaToggleBody>
            <ToggleLabelText dangerouslySetInnerHTML={{ __html: appAnalyticsContent }} />
            <WjaToggleBodyExtens>
              <WjaToggleBodyExtensContainer>
                <WjaToggleBodyExtensContainerDesc>
                  {appOptionalDataUseDesc}
                </WjaToggleBodyExtensContainerDesc>
                <WjaToggleBodyExtensContainerButton>
                  <Toggle
                    data-testid="setAnalytics-btn"
                    id="app-analytics-toggle"
                    defaultOn={analytics}
                    on={analytics}
                    onChange={(e) => {
                      setAnalytics(e);
                      setRenderPageAnyToggleClick(true);
                    }}
                  />
                  <WjaToggleBodyExtensContainerButtonText>
                    {analytics ? 'On' : 'Off'}
                  </WjaToggleBodyExtensContainerButtonText>
                </WjaToggleBodyExtensContainerButton>
              </WjaToggleBodyExtensContainer>
            </WjaToggleBodyExtens>
          </WjaToggleBody>
        </WjaContainer>
      ),
      header: {
        centralArea: <ToggleLabelHeader>{appOptionalTitle}</ToggleLabelHeader>
      },
      id: 'app-analytics-accordion-item',
      expanded: true
    }
  ];

  const piplUserConsentsAccordionItems = [
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: dataTransferContent }} />,
      header: {
        startArea: <IconShare id="graphic-data-transfer" alt="data-transfer" />,
        centralArea: <ToggleLabelHeader>{appDataTransferTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setDataTransfer-btn"
            id="dataTransfer-toggle"
            defaultOn={dataTransfer}
            on={dataTransfer}
            onChange={(e) => {
              setDataTransfer(e);
              setAnalytics(false);
              setAdvertising(false);
              setPersonalizedSuggestions(false);
            }}
          />
        )
      },
      id: 'data-transfer-accordion-item',
      expanded: true
    },
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: appAnalyticsContent }} />,
      header: {
        startArea: <Graphic id="graphic-analytics" src={svgAnalytics} alt="analytics" />,
        centralArea: <ToggleLabelHeader>{appAnalyticsTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setAnalytics-btn"
            id="app-analytics-toggle"
            disabled={!dataTransfer}
            defaultOn={analytics}
            on={analytics}
            onChange={(e) => {
              setAnalytics(e);
            }}
          />
        )
      },
      id: 'app-analytics-accordion-item',
      expanded: true
    },
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: advertisingContent }} />,
      header: {
        startArea: <IconMegaphone id="graphic-advertising" alt="advertising" />,
        centralArea: <ToggleLabelHeader>{advertisingTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setAdvertising-btn"
            id="advertising-toggle"
            disabled={!dataTransfer}
            defaultOn={advertising}
            on={advertising}
            onChange={(e) => {
              setAdvertising(e);
            }}
          />
        )
      },
      id: 'advertising-accordion-item',
      expanded: isDesktop
    },
    {
      content: (
        <ToggleLabelText
          dangerouslySetInnerHTML={{
            __html: personalizedSuggestionsContent
          }}
        />
      ),
      header: {
        startArea: (
          <Graphic id="graphic-personalized-suggestions" src={svgPersonalized} alt="personalized" />
        ),
        centralArea: <ToggleLabelHeader>{personalizedTitle}</ToggleLabelHeader>,
        endArea: (
          <Toggle
            data-testid="setPersonalizedSuggestions-btn"
            id="personalized-suggestions-toggle"
            disabled={!dataTransfer}
            defaultOn={personalizedSuggestions}
            on={personalizedSuggestions}
            onChange={(e) => {
              setPersonalizedSuggestions(e);
            }}
          />
        )
      },
      id: 'personalized-suggestions-accordion-item',
      expanded: isDesktop
    }
  ];

  const piplPrinterConsentsAccordionItems = [
    {
      content: <ToggleLabelText dangerouslySetInnerHTML={{ __html: defaultConsentContent }} />,
      header: {
        startArea: <IconJobs id="graphic-required" alt="required" />,
        centralArea: <ToggleLabelHeader>{appRequiredTitle}</ToggleLabelHeader>
      },
      id: 'app-required-accordion-item',
      expanded: true
    },
    ...piplUserConsentsAccordionItems
  ];

  if (printerWelcome) {
    return (
      <StyledAccordion
        behavior={isDesktop ? 'multiExpand' : 'singleExpand'}
        items={!isPipl ? printerConsentsAccordionItems : piplPrinterConsentsAccordionItems}
        id="privacy-consents-items"
      />
    );
  }
  return (
    <StyledAccordion
      behavior={isDesktop ? 'multiExpand' : 'singleExpand'}
      items={
        hasAppNameWJA
          ? wjaConsentsAccordionItems
          : !isPipl
          ? userConsentsAccordionItems
          : piplUserConsentsAccordionItems
      }
      isWJA={hasAppNameWJA}
      id="privacy-consents-items"
    />
  );
};

export default PrivacyConsents;
